import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "@/store/user";

export default function CheckoutSuccessPage() {
  const navigate = useNavigate();
  const { subInfo, refreshSubscription } = useUser();

  useEffect(() => {
    refreshSubscription();
  }, [refreshSubscription]);

  const expires = subInfo?.subscription?.expires_at
    ? new Date(subInfo.subscription.expires_at).toLocaleDateString("ar-EG", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";

  return (
    <div className="shell" data-testid="checkout-success-page">
      <div
        className="panel"
        style={{
          maxWidth: 540,
          margin: "60px auto",
          padding: 36,
          textAlign: "center",
          border: "1px solid #2ec48e55",
          boxShadow: "0 10px 40px #2ec48e22",
        }}
      >
        <div style={{ fontSize: 64, marginBottom: 8 }}>🎉</div>
        <h2 style={{ marginBottom: 12 }}>تمّ تفعيل اشتراكك بنجاح!</h2>
        <p
          className="muted"
          style={{ lineHeight: 1.9, marginBottom: 22, fontSize: 15 }}
        >
          مرحبًا بك في عالم Balagha Premium 💎. أصبحَ بإمكانك الآن الوصول إلى
          جميع المسارات المدفوعة والاختبارات والشهادات.
          {expires && (
            <>
              <br />
              <span style={{ fontSize: 13, opacity: 0.85 }}>
                صلاحيّة اشتراكك حتى:{" "}
                <strong style={{ color: "#2ec48e" }}>{expires}</strong>
              </span>
            </>
          )}
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button
            className="btn btn-primary"
            onClick={() => navigate("/tracks")}
            data-testid="success-go-tracks"
            style={{ padding: "12px 22px", fontWeight: 700 }}
          >
            ابدأ التعلّم الآن →
          </button>
          <button
            className="btn btn-ghost"
            onClick={() => navigate("/profile")}
            data-testid="success-go-profile"
            style={{ padding: "12px 22px" }}
          >
            عرض اشتراكي
          </button>
        </div>
      </div>
    </div>
  );
}
